"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var Search = function Search(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M94.485 89.536L62.95 58 58 62.95l31.536 31.535a2 2 0 0 0 2.828 0l2.121-2.121a2 2 0 0 0 0-2.828z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38 69c17.12 0 31-13.88 31-31C69 20.88 55.12 7 38 7 20.88 7 7 20.88 7 38c0 17.12 13.88 31 31 31zm0 7C17.013 76 0 58.987 0 38S17.013 0 38 0s38 17.013 38 38-17.013 38-38 38z"
  }))));
};
var _default = exports.default = Search;